import { useMemo } from 'react';

import { useDriveConversationsQuery } from '@occc/graphql';

import { truncateText } from '../../utils/text-utils';

const MAX_RECENT_CONVERSATIONS = 5;
const TRUNCATE_LENGTH = 35;

type RecentConversation = {
  id: string;
  name: string;
};

type UseRecentConversationsResult = {
  conversations: RecentConversation[];
  loading: boolean;
};

export const useRecentConversations = (): UseRecentConversationsResult => {
  const { data, loading } = useDriveConversationsQuery({
    variables: { first: MAX_RECENT_CONVERSATIONS },
    fetchPolicy: 'cache-and-network',
  });

  const conversations = useMemo<RecentConversation[]>(
    () =>
      data?.driveConversations.edges.map((edge) => {
        const firstPrompt = edge.node.prompts[0];
        const name = firstPrompt ? truncateText(firstPrompt.content, TRUNCATE_LENGTH) : 'Untitled';

        return {
          id: edge.node.id,
          name,
        };
      }) ?? [],
    [data],
  );

  return {
    conversations,
    loading,
  };
};
